import _ from 'underscore';

import {decodeJQueryParam, getLocationHref, parseUri, setLocationHref, setURLParams} from 'BenchlingUtil';

// BenchlingUtil.redirectToSignup() drops the current page's query string. Standalone Model Hub
// traffic often arrives with campaign/attribution params on `/` or `/models`; preserve those on
// the redirect to `/signup` so downstream signup analytics and integrations still see them.
export function redirectToModelHubSignup(): void {
  const {queryKey} = parseUri(getLocationHref());
  const params = _.object(
    // eslint-disable-next-line no-restricted-syntax
    _.map(_.pairs(queryKey), ([key, value]) => [key, decodeJQueryParam(value)])
  );
  setLocationHref(setURLParams('/signup', params));
}
